/* eslint-disable no-undef */
/* eslint-disable array-callback-return */
// <copyright file="MeetingTranscriptRecording.jsx" company="Microsoft Corporation">
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// </copyright>

import React, { useState, useEffect } from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import { Body1, Caption1, Button, Text, Card, Spinner } from '@fluentui/react-components';
import { CardFooter } from 'reactstrap';

const MeetingTranscriptRecording = () => {


    // Define an array state variable with an initial value
    const [cardData, setData] = useState([]);

    // Define a state variable to manage the visibility of the consent button
    const [IsConsentButtonVisible, setIsConsentButtonVisible] = useState(false);

    // Define a state variable to manage the visibility of the login button
    const [IsLoginVisible, setIsLoginVisible] = useState(true);

    const [IsErrorVisible, setIsErrorVisible] = useState(false);
    const [errorText, setErrorText] = useState("");

    // Define a state variable to manage the visibility of the card visible
    const [IsCardVisible, setIsCardVisible] = useState(false);

    // Define a state variable to manage the visibility of the card visible
    const [HasRecordings, setHasRecordings] = useState(false);

    const [loading, setLoading] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);

    const [loginAdminAccount, setloginAdminAccount] = useState(false);

    // Tab sso authentication.
    const ssoAuthentication = () => {
        
        setLoading(true);
        getClientSideToken()
            .then((clientSideToken) => {
                return getServerSideToken(clientSideToken);
            })
            .catch((error) => {
                if (error === "invalid_grant") {
                    // Display an in-line button so the user can consent
                    setIsConsentButtonVisible(true);
                }
            });
    }

    // Get client-side token.
    const getClientSideToken = () => {
        return new Promise((resolve, reject) => {
            microsoftTeams.authentication.getAuthToken()
                .then((result) => {
                    resolve(result);
                })
                .catch((error) => {
                    setIsErrorVisible(true);
                    let errortext = "Error getting token: " + error;
                    setErrorText(errortext);
                    reject(errortext);
                });
        });
    }

    // Get server-side token and user profile.
    const getServerSideToken = (clientSideToken) => {
        return new Promise((resolve, reject) => {
            microsoftTeams.app.getContext().then((context) => {
                fetch('/GetRecordingInformation', {
                    method: 'get',
                    headers: {
                        "Content-Type": "application/text",
                        "Authorization": "Bearer " + clientSideToken
                    },
                    cache: 'default'
                })
                .then((response) => {
                    if (response.ok) {
                        setHasRecordings(false);
                        return response.text();
                    }
                })
                .then((responseJson) => {
                    if (responseJson === "" || responseJson === "[]" || responseJson === "{}") {
                        setIsLoginVisible(false);
                        setLoading(false);
                    }
                    else if (responseJson !== undefined) {
                        setIsLoginVisible(false);
                        setIsCardVisible(true);
                        let userDetails = JSON.parse(responseJson);
                        setHasRecordings(true);
                        setData(userDetails);
                        setLoading(false);
                    }
                });
            });
        });
    }

    // Request consent on implicit grant error.
    const requestConsent = () => {
        getToken()
            .then(data => {
                setIsConsentButtonVisible(false);
                getClientSideToken()
                    .then((clientSideToken) => {
                        return getServerSideToken(clientSideToken);
                    });
            });
    }

    // Get token for multi-tenant.
    const getToken = () => {
        return new Promise((resolve, reject) => {
            microsoftTeams.authentication.authenticate({
                url: globalThis.location.origin + "/auth-start",
                width: 600,
                height: 535
            })
                .then((result) => {
                    resolve(result);
                    setLoading(true);
                })
                .catch((reason) => {
                    setloginAdminAccount(true);
                    setIsConsentButtonVisible(false);
                    setIsLoginVisible(false);
                    setLoading(false);
                });
        });
    }


    const getFormattedDate = (dateZ) => {
        let localDate = new Date(dateZ);
        // Return a formatted local date-time string
        return localDate.toLocaleString("nl-NL", {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        });
    }

    const postrecording = (onlineMeetingId, recordingId, initiator, participants, recordingtype) => () => {
        getClientSideToken()
            .then((clientSideToken) => {
                microsoftTeams.app.getContext().then((context) => {
                    const newList = [];
                    Object.keys(cardData).map((key) => {
                        const item = cardData[key]
                        if (item.onlineMeetingId === onlineMeetingId) {
                            const updatedItem = {
                                ...item,
                                uploadMessage: "",
                                upLoading: true,
                            };
                            newList.push(updatedItem);
                        }
                        else {
                            newList.push(item);
                        }
                    });
                    
                    setData(newList);
                    
                    return new Promise((resolve, reject) => {
                        fetch('/UploadRecording', {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json; charset=utf-8',
                                'Content-Type': 'application/json;charset=UTF-8',
                                'Authorization': "Bearer " + clientSideToken
                            },
                            body: JSON.stringify({
                                meetingId: onlineMeetingId,
                                recordingId: recordingId,
                                initiator: initiator,
                                participants: participants,
                                recordingtype: recordingtype
                            })
                        })
                            .then(async (response) => {
                                const newList = [];
                                const uploadResponse = await response.json();
                                Object.keys(cardData).map((key) => {
                                    const item = cardData[key]
                                    if (item.onlineMeetingId === onlineMeetingId) {
                                        const updatedItem = {
                                            ...item,
                                            uploadSuccess: uploadResponse.outcome === true, //response.ok,
                                            upLoading: false,
                                            uploadState: "attempted",
                                            uploadMessage: uploadResponse.inner ? JSON.parse(uploadResponse.inner).detail : (uploadResponse.error ? uploadResponse.error : "")
                                        };
                                        newList.push(updatedItem);
                                    }
                                    else {
                                        newList.push(item);
                                    }
                                });
                                setData(newList);
                                
                            });
                    });
                });
            });
    }

    useEffect(() => {
        if (firstLoad) {
            //try automatic sso login only once
            setFirstLoad(false);
            setLoading(true);
            getClientSideToken()
                .then((clientSideToken) => {
                    return getServerSideToken(clientSideToken);
                })
                .catch((error) => {
                    if (error === "invalid_grant") {
                        // Display an in-line button so the user can consent
                        setIsConsentButtonVisible(true);
                    }
                });
        }

    }, [firstLoad, setFirstLoad]);

    return (
        <div className="">
            {(!firstLoad && !loading) && (IsLoginVisible || IsConsentButtonVisible || loginAdminAccount) &&
                <div className="btnLogin">
                    {IsLoginVisible &&
                        <>
                            <Button appearance="primary" onClick={ssoAuthentication}>Sign-In</Button>
                        </>
                    }
                    {(IsConsentButtonVisible) &&
                        <>
                            <div id="divError">Please click on consent button</div>
                            <Button appearance="primary" onClick={requestConsent}>Consent</Button>
                        </>
                    }

                    {loginAdminAccount &&
                        <>
                            <h3>Please login with admin account.</h3>
                        </>
                    }

                    {IsErrorVisible &&
                        <>
                            <h3>An error occurred</h3>
                            <p>{errorText}</p>
                        </>
                    }
                </div>
            }
            <div className="mainCard">
                {loading &&
                    <>
                        <div className="loadingIcon">
                            <Spinner label="Loading Recordings..." size="large" />
                        </div>
                    </>
                }
                {!loading && !HasRecordings &&
                    <>
                    <div className="messageBlock">
                        <h3>No recent recordings found.</h3>
                    </div>
                    </>}
                {IsCardVisible &&
                    <>
                        {Object.keys(cardData).map((key) => {
                            const element = cardData[key]
                            const labelClass = `recordingLabel lbl${element.recordingtype}`
                            return (
                                <div key={key} className="divMainCard">
                                    <Card>
                                        <header>
                                                <Body1>
                                                    <Text className="txtMeetingTitle" weight='bold' as="h1">{element.subject}</Text>
                                                </Body1>
                                            <div>
                                                <Caption1><Text className="meetingDate">{getFormattedDate(element.startZ)} - {getFormattedDate(element.endZ)} ({element.duration})</Text></Caption1>
                                            </div>
                                            
                                        </header>
                                        
                                        <div className={ labelClass }>
                                            <Text className="meetingType">{element.recordingtype }</Text>
                                        </div>
                                        <CardFooter className="btnCard">
                                        
                                            {element.upLoading ? (
                                                <div>
                                                    <Spinner label="Uploading..." size="large" />
                                                </div>
                                            ) : (
                                                <div>
                                                <Button appearance="primary" disabled={!element.condition || element.uploadSuccess === true} onClick={postrecording(element.onlineMeetingId, element.recordingId, element.organizer, element.participants, element.recordingtype)}>
                                                    {element.uploadState === "new"
                                                    ? "Upload this recording to In2dialog"
                                                        : element.uploadSuccess
                                                        ? "Uploaded to In2dialog"
                                                        : "Upload failed - retry"}
                                                </Button>
                                                
                                                {(element.uploadMessage !== "" && element.uploadMessage !== undefined) ? (
                                                <span className="uploadErrorBlock">{element.uploadMessage}</span>
                                                    ) : null }
                                                        
                                                </div>
                                                
                                            )}
                                        
                                        </CardFooter>
                                    </Card>
                                </div>
                            );
                        })}
                    </>
                }
            </div>
            <span className="versionBlock">Version: {window.ClientAppVersion}</span>
        </div>
    );
};

export default MeetingTranscriptRecording;
